export default "__VITE_ASSET__91b2a660__"